import { useContext } from "react";
import { CoreContext } from "../components/common/CoreProvider";

const useCoreContext = () => {
  return useContext(CoreContext);
};

export default useCoreContext;
